import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import type { ImmutableTrip } from 'src/types/trips/Trips';
import Modal from 'src/common/components/Modal';
import { FORMS } from 'src/inbox/constants';
import dateTimeDurationSelector from 'src/inbox/selectors/dateTimeDuration/dateTimeDuration';
import TimeForm from './form';

type TimeModalProps = {
  trip: ImmutableTrip;
};

const TimeModal: FC<TimeModalProps> = ({ trip }) => {
  const { offerTrip: { hasPickupTime, startTime, endTime } } = useSelector(dateTimeDurationSelector(trip.get('pk')));

  return (
    <Modal
      name={FORMS.TIME}
      label="Time Form"
    >
      <TimeForm
        initialValues={!hasPickupTime ? {} : {
          pickup_time: startTime,
          return_time: endTime,
        }}
        trip={trip}
      />
    </Modal>
  );
};

export default TimeModal;
